import { useQuery } from '@tanstack/react-query';
import { getConversations } from '../api/conversations';

export function useConversations() {
  return useQuery({
    queryKey: ['conversations'],
    queryFn: getConversations,
    refetchInterval: 15000,
    refetchIntervalInBackground: false,
  });
}
